import React, { useMemo, useState } from "react";
import { Box, Divider } from "@mui/material";
import SearchBar from "../../../../Components/inputTypes/searchBar/searchBar";
import FilterIcon from "../../../../Components/Icons/filterIcon";
import { useAgentsStore } from "../../store/agents.store";
import {
    selectAgentsCountWithSegregation,
    selectFilters,
    selectSearchParam,
} from "../../store/agentsSelectors";
import {
    AGENTS_TBL_ALL_COLUMN_TITLES,
    AGENTS_TBL_FIXED_COLS,
    AGENT_STATUS_COLORS,
} from "../../agents.constants";
import { AgentMetricTag } from "../agentMetricTag/agentMetricTag.index";
import styles from "./agentsHeader.module.css";
import { ColumnConfig } from "../../../escalatedPage/components/columnConfig/columnConfig.index";
import { countActiveAgentFilters } from "./agentsHeader.utils";
import { AgentsFilterShowcase } from "./components/filterShowcase/agentsFilterShowcase.index";
import { AgentsFilterPopup } from "./components/agentsFilterPopup/agentsFilterPopup.index";

interface AgentsHeaderProps {
    onSearch: (value: string) => void;
    visibleColumns: string[] | null;
    setVisibleColumns: React.Dispatch<React.SetStateAction<string[] | null>>;
}

export const AgentsHeader = ({
    onSearch,
    visibleColumns,
    setVisibleColumns,
}: AgentsHeaderProps) => {
    const agentsCount = useAgentsStore(selectAgentsCountWithSegregation);
    const searchParam = useAgentsStore(selectSearchParam);
    const filters = useAgentsStore(selectFilters);
    const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);

    const filterCount = useMemo(
        () => countActiveAgentFilters(filters),
        [filters]
    );

    return (
        <div className={styles.agentsHeader}>
            <div className={styles.agentsHeaderLeftCtn}>
                <div className={styles.agentsHeaderLeft}>
                    <span className={styles.agentsHeaderTitle}>
                        Total Agents: {agentsCount.totalAgents}
                    </span>
                    <Divider orientation="vertical" flexItem className={styles.agentsHeaderDivider} />
                    <div className={styles.agentsHeaderMetrics}>
                        <AgentMetricTag
                            label="Active"
                            value={agentsCount.activeAgents}
                            color={AGENT_STATUS_COLORS.active}
                        />
                        <AgentMetricTag
                            label="Inactive"
                            value={agentsCount.inactiveAgents}
                            color={AGENT_STATUS_COLORS.inactive}
                        />
                    </div>
                    <Divider orientation="vertical" flexItem className={styles.agentsHeaderDivider} />
                    <Box
                        className={styles.filterContainer}
                        onClick={() => setIsFilterPopupOpen(true)}
                    >
                        <FilterIcon />
                        {filterCount > 0 && (
                            <span className={styles.filterBadge}>{filterCount}</span>
                        )}
                    </Box>
                </div>
                <AgentsFilterShowcase />
            </div>
            <div className={styles.agentsHeaderRight}>
                <SearchBar
                    searchText={searchParam ?? ""}
                    onSearch={onSearch}
                    placeholder="Search agents"
                />
                <ColumnConfig
                    headerNames={[...AGENTS_TBL_ALL_COLUMN_TITLES]}
                    fixedColumns={[...AGENTS_TBL_FIXED_COLS]}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                />
            </div>
                <AgentsFilterPopup
                    isOpen={isFilterPopupOpen}
                    onClose={() => setIsFilterPopupOpen(false)}
                />
        </div>
    );
};
